import styled, { css } from 'styled-components'

type LayoutContainerProps = {
  background: string | undefined,
  hideItemStructure?: boolean
}

export const LayoutContainer = styled.main<LayoutContainerProps>`
  background: ${({ background }) => background || '#8A2BE2'};

  display: flex;
  flex-direction: column;

  height: 100vh;

  padding: 0 .4rem;

  header {
    padding: 1rem .2rem;

    position: absolute;
    left: 50%;
    transform: translateX(-50%);

    button {
      background: none;
    }
  }

  .container {
    flex: 1;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    padding-top: 3rem;

    .logo {
      max-width: 25rem;
      width: 60%;

      margin-bottom: 3rem;

      img {
        width: 100%;

        transform: rotate(-10deg);
      }

      @media (max-width: 400px) {
        width: 60%;
      }

      @media (max-width: 350px) {
        width: 70%;
      }
    }

    ${({ hideItemStructure }) => !hideItemStructure && css`
      > div:last-child {
        background: #f2f2f2;
        border-radius: 1.6rem;

        width: 95%;
        min-height: 23rem;

        padding: 2rem;
      }
    `}
  }
`
